import { render, staticRenderFns } from "./IncedentDetails.vue?vue&type=template&id=117f5640&scoped=true"
import script from "./IncedentDetails.vue?vue&type=script&lang=js"
export * from "./IncedentDetails.vue?vue&type=script&lang=js"
import style0 from "./IncedentDetails.vue?vue&type=style&index=0&id=117f5640&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117f5640",
  null
  
)

export default component.exports